import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  Component,
} from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import {
  DownloadClientsDataInExcel,
  FilterJsonExactlyMatching,
  formateDate,
  getEndOfMonth,
  getStartOfMonth,
  SortTheList,
} from "../Shared/Utility";
import ConfirmationModal from "../App/ConfirmationModal";
import { useGlobalState } from "../Context/GlobalStateContext";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import MobileInput from "../MobileInput/MobileInput";
import { useSearchParams } from "react-router-dom";
import { showErrorMessage } from "../Shared/Toast";
import PaginatedItems from "../Pagination/Pagination";

function Clients() {
  const globalState = useGlobalState();
  const [searchParams] = useSearchParams();
  const selectedMoverID: any = searchParams.get("ID");
  const [isAnimation, setIsAnimation] = useState(false);
  const [isAddNew, setIsAddNew] = useState(0);
  const [thisAllData, setThisAllData] = useState<any>([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [addEditObject, setAddEditObject] = useState<any>({
    MNVClientID: 0,
    TypeID: "",
    BusinessName: "",
    FirstName: "",
    LastName: "",
    EmailAddress: null,
    Mobile: "",
    Telephone: "",
    PostCode: "",
    Address: "",
    AddressLine2: "",
    VATNumber: "",
    ExtraTextField1: "",
    OtherEmails: "",
    SurName: "",
    CreationTimestamp: "",
  });

  const [filterObject, setFilterObject] = useState<any>({
    MNVClientID: 0,
    TypeID: 0,
    BusinessName: "",
    FirstName: "",
    LastName: "",
    EmailAddress: "",
    Mobile: "",
    StartDate: null,
    EndDate: null,
  });

  const [screenData, setScreenData] = useState<any>([]);

  useEffect(() => {
    LoadUsersData();
  }, []);

  function LoadUsersData() {
    let object = {} as any;
    object.MNVClientID = filterObject.MNVClientID;
    object.TypeID = filterObject.TypeID;
    object.BusinessName = filterObject.BusinessName;
    object.FirstName = filterObject.FirstName;
    object.LastName = filterObject.LastName;
    object.EmailAddress = filterObject.EmailAddress;
    object.Mobile = filterObject.Mobile;
    object.StartDate = filterObject.StartDate;
    object.EndDate = filterObject.EndDate;
    object.PageIndex = thisComponentObject.PageIndex;
    object.RecordsPerPage = thisComponentObject.RecordsPerPage;
    setIsAnimation(true);
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVClient/MNVClientGetCompleteGridDataV2",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data[0];
          let TotalCount = response.data.Data[1][0].TotalCount;
          if (selectedMoverID && selectedMoverID > 0) {
            l_oResponse = FilterJsonExactlyMatching(
              l_oResponse,
              "UserReviewID",
              selectedMoverID,
            );
          }
          const deepCopy1 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy2 = JSON.parse(JSON.stringify(l_oResponse));
          const deepCopy3 = JSON.parse(JSON.stringify(l_oResponse));
          setThisAllData(deepCopy3);
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2);
          thisGridListDataRef.current = deepCopy2;
          setScreenData(l_oResponse);
          setThisComponentObject((prevState) => ({
            ...prevState,
            TotalCount: TotalCount,
          }));
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function checkValidation(actionType?: string) {
    var IsOkay = true;
    if (!addEditObject.TypeID || addEditObject.TypeID == 0) {
      showErrorMessage("Please select Type");
      IsOkay = false;
    } else if (!addEditObject.FirstName || addEditObject.FirstName == "") {
      showErrorMessage("Please enter First Name");
      IsOkay = false;
    }

    if (IsOkay == true) {
      saveScreenData();
    }
  }

  function saveScreenData() {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVClientID = addEditObject.MNVClientID;
    object.TypeID = addEditObject.TypeID;
    object.BusinessName = addEditObject.BusinessName;
    object.FirstName = addEditObject.FirstName;
    object.LastName = addEditObject.LastName;
    object.EmailAddress = addEditObject.EmailAddress;
    object.Mobile = SelectedMobileNumber;
    object.Telephone = addEditObject.Telephone;
    object.PostCode = addEditObject.PostCode;
    object.Address = addEditObject.Address;
    object.AddressLine2 = addEditObject.AddressLine2;
    object.VATNumber = addEditObject.VATNumber;
    object.ExtraTextField1 = addEditObject.ExtraTextField1;
    object.OtherEmails = addEditObject.OtherEmails;
    object.SurName = addEditObject.SurName;
    object.CreationTimestamp = addEditObject.CreationTimestamp;

    axiosAuth
      .post(AppContext.APIURL + "api/MNVClient/MNVClientSave", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setIsAddNew(0);
          LoadUsersData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function deleteThisRecord(pid: any) {
    setIsAnimation(true);
    let object = {} as any;
    object.MNVClientID = pid;

    axiosAuth
      .post(AppContext.APIURL + "api/MNVClient/MNVClientDeleteRecord", object)
      .then((response) => {
        if (response.data.Status === 1) {
          // SaveFiles();
          LoadUsersData();
        }
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        deleteThisRecord(obj.SelectedID);
      }
    }
    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  const baseUrl = "https://mnvapp.currentdomain.co.uk/dashboard";
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({
        x: event.clientX,
        y: event.clientY,
        totalWidth: window.innerWidth,
        totalHeight: window.innerHeight,
      });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = [];
    l_data = [...FilterData];
    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];

    if (isFirstTime == false) {
      setIsFilterApplied(true);
    }

    setIsFirstTime(false);
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy);
    thisGridListDataRef.current = deepCopy;
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  const [filters, setFilters] = useState(["", "D"]);

  useLayoutEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "MNVClientID")) {
        (
          document.getElementById("imgSort" + "MNVClientID") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "TypeIDName")) {
        (
          document.getElementById("imgSort" + "TypeIDName") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "BusinessName")) {
        (
          document.getElementById(
            "imgSort" + "BusinessName",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSort" + "FirstName")) {
        (
          document.getElementById("imgSort" + "FirstName") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  const [SelectedMobileNumber, SetSelectedMobileNumber] = useState("");

  useEffect(() => {
    // console.log("Mobile", addEditObject.Mobile);
    SetSelectedMobileNumber(addEditObject.Mobile);
  }, [addEditObject.Mobile, isAddNew]);

  useEffect(() => {
    setAddEditObject((prevState: any) => ({
      ...prevState,
      MobileNo: SelectedMobileNumber,
    }));
  }, [SelectedMobileNumber]);

  ////  Pagination Starts    ////

  const [thisComponentObject, setThisComponentObject] = useState({
    TotalCount: 0,
    PageIndex: 0,
    RecordsPerPage: 100,
    Refresh: false,
  });

  useEffect(() => {
    if (thisComponentObject.TotalCount > 0) {
      LoadUsersData();
    }
  }, [
    thisComponentObject.PageIndex,
    thisComponentObject.RecordsPerPage,
    thisComponentObject.Refresh,
  ]);

  function HandlePageIndexCallback(PageIndex: any) {
    setThisComponentObject((prevState) => ({
      ...prevState,
      PageIndex: PageIndex,
    }));
  }

  function HandlePageSelectionCallback(RecordsPerPage: any) {
    setThisComponentObject((prevState) => ({
      ...prevState,
      RecordsPerPage: RecordsPerPage,
      PageIndex: 0,
    }));
  }

  ////  Pagination Ends    ////

  return (
    <div className="inline-block-d width-100 p-all10">
      {isAnimation && <LoadingAnimation />}
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />

      {/* {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListDataWithoutFilters}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )} */}

      {isAddNew == 0 && (
        <>
          <div className="flex-d justify-btw mb-10">
            <div className="flex-da gap-10">
              <div className="field-input">
                <select
                  className="input-field"
                  value={filterObject.TypeID}
                  onChange={(e) =>
                    setFilterObject((prevState: any) => ({
                      ...prevState,
                      TypeID: parseInt(e.target.value),
                    }))
                  }
                >
                  <option value="0">Type</option>
                  <option value="2">Residential</option>
                  <option value="1">Business</option>
                </select>

                {/* <input
                  className="input-field"
                  placeholder="Type ID"
                  value={filterObject.TypeID}
                  onChange={(e) =>
                    setFilterObject((prevState: any) => ({
                      ...prevState,
                      TypeID: e.target.value,
                    }))
                  }
                ></input> */}
              </div>
              <div className="field-input">
                <input
                  className="input-field"
                  placeholder="Business Name"
                  value={filterObject.BusinessName}
                  onChange={(e) =>
                    setFilterObject((prevState: any) => ({
                      ...prevState,
                      BusinessName: e.target.value,
                    }))
                  }
                ></input>
              </div>
              <div className="field-input">
                <input
                  className="input-field"
                  placeholder="First Name"
                  value={filterObject.FirstName}
                  onChange={(e) =>
                    setFilterObject((prevState: any) => ({
                      ...prevState,
                      FirstName: e.target.value,
                    }))
                  }
                ></input>
              </div>
              <div className="field-input">
                <input
                  className="input-field"
                  placeholder="Last Name"
                  value={filterObject.LastName}
                  onChange={(e) =>
                    setFilterObject((prevState: any) => ({
                      ...prevState,
                      LastName: e.target.value,
                    }))
                  }
                ></input>
              </div>
              <div className="field-input">
                <input
                  className="input-field"
                  placeholder="Email"
                  value={filterObject.EmailAddress}
                  onChange={(e) =>
                    setFilterObject((prevState: any) => ({
                      ...prevState,
                      EmailAddress: e.target.value,
                    }))
                  }
                ></input>
              </div>
              <div className="field-input">
                <input
                  className="input-field"
                  placeholder="Mobile"
                  value={filterObject.Mobile}
                  onChange={(e) =>
                    setFilterObject((prevState: any) => ({
                      ...prevState,
                      Mobile: e.target.value,
                    }))
                  }
                ></input>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => LoadUsersData()}
                >
                  Filter
                </a>
              </div>
            </div>

            <div className="flex-daj flex-gap10">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setAddEditObject({
                      MNVClientID: 0,
                      TypeID: "",
                      BusinessName: "",
                      FirstName: "",
                      LastName: "",
                      EmailAddress: null,
                      Mobile: "",
                      Telephone: "",
                      PostCode: "",
                      Address: "",
                      AddressLine2: "",
                      VATNumber: "",
                      ExtraTextField1: "",
                      OtherEmails: "",
                      SurName: "",
                      CreationTimestamp: "",
                    });
                    setIsAddNew(1);
                    SetSelectedMobileNumber("");
                  }}
                >
                  Add New
                </a>
              </div>
              <a
                className="btn-primary flex-daj btn-grid"
                title="Export"
                onClick={() =>
                  DownloadClientsDataInExcel("tblclients", "Clients")
                }
              >
                <img src="images/export.svg" width="18" height="18" />
              </a>
            </div>
          </div>
          <div className="flow-auto">
            <table className="reuse-table" id="tblclients">
              <thead>
                <tr>                  
                  <th>Action</th>
                  <th>Creation Date</th>
                  {/* <th>
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Client ID
                        {/* <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "MNVClientID")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a>
                        <a
                          onClick={() => LoadWithSelectedSort("MNVClientID")}
                          title={"Sort By Client ID"}
                        >
                          <span id={"imgSort" + "MNVClientID"}></span>
                        </a>
                      </div>
                    </div>
                  </th> */}
                  <th className="reuse-tdsm">
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Type
                        {/* <a
                          onClick={(e) => ShowColumnFilterList(e, "TypeIDName")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a> */}
                        <a
                          onClick={() => LoadWithSelectedSort("TypeIDName")}
                          title={"Sort By Type Name"}
                        >
                          <span id={"imgSort" + "TypeIDName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th className="reuse-tdsm3">
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        Business Name
                        {/* <a
                          onClick={(e) =>
                            ShowColumnFilterList(e, "BusinessName")
                          }
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a> */}
                        <a
                          onClick={() => LoadWithSelectedSort("BusinessName")}
                          title={"Sort By Business Name"}
                        >
                          <span id={"imgSort" + "BusinessName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th className="reuse-tds2">
                    <div className="flex-daj flex-gap20">
                      <div className="flex-da flex-gap5">
                        First Name
                        {/* <a
                          onClick={(e) => ShowColumnFilterList(e, "FirstName")}
                          data-function="ShowColumnFilterList"
                        >
                          <img
                            src="images/icon-search-w.svg"
                            width={15}
                            height={15}
                            alt="search"
                          />
                        </a> */}
                        <a
                          onClick={() => LoadWithSelectedSort("FirstName")}
                          title={"Sort By First Name"}
                        >
                          <span id={"imgSort" + "FirstName"}></span>
                        </a>
                      </div>
                    </div>
                  </th>
                  <th className="reuse-tdsm2">Last Name</th>
                  <th className="reuse-tdsm4">Email</th>
                  <th className="reuse-tdsm2">Mobile</th>
                  <th className="reuse-tdsm2">Telephone</th>
                  <th className="reuse-tdsm">Postcode</th>
                  <th className="reuse-tdsm">Address Line 1</th>
                  <th className="reuse-tdsm">Address Line 2</th>
                  <th className="reuse-tdsm">VAT Number</th>
                  <th className="reuse-tdsm">Company Number</th>
                  <th className="reuse-tdsm4">Other Emails</th>
                  <th className="reuse-tdsm">Payment Term</th>
                </tr>
              </thead>
              <tbody>
                {thisGridListData &&
                  thisGridListData.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!item.IsExcluded && (
                        <tr>
                          <td>
                            <div className="flex-daj gap-10">
                              {/* <a
                                href={`/calendar?cid=${item.MNVClientID}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Preview"
                              >
                                <img
                                  src="images/eye-t.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a> */}                              
                              <a
                                onClick={() =>
                                  globalState.setConfirmationModalObject({
                                    ShowPopup: true,
                                    Heading: "Alert",
                                    Message:
                                      "Are your sure, you want to delete this record?",
                                    ID: 1,
                                    SelectedID: item.MNVClientID,
                                    OtherID: 0,
                                  })
                                }
                              >
                                <img
                                  src="images/delete.png"
                                  width="18px"
                                  height="18px"
                                  alt="Delete"
                                />
                              </a>
                              <a
                                onClick={() => {
                                  setIsAddNew(2);
                                  SetSelectedMobileNumber("");
                                  setAddEditObject({
                                    MNVClientID: item.MNVClientID,
                                    TypeID: item.TypeID,
                                    BusinessName: item.BusinessName,
                                    FirstName: item.FirstName,
                                    LastName: item.LastName,
                                    EmailAddress: item.EmailAddress,
                                    Mobile: item.Mobile,
                                    Telephone: item.Telephone,
                                    PostCode: item.PostCode,
                                    Address: item.Address,
                                    AddressLine2: item.AddressLine2,
                                    VATNumber: item.VATNumber,
                                    ExtraTextField1: item.ExtraTextField1,
                                    OtherEmails: item.OtherEmails,
                                    SurName: item.SurName,
                                    CreationTimestamp: item.CreationTimestamp,
                                  });
                                }}
                              >
                                <img
                                  src="images/edit.svg"
                                  width="18px"
                                  height="18px"
                                  alt="Edit"
                                />
                              </a>
                            </div>
                          </td>                          
                          <td>{formateDate(item.CreationTimestamp)}</td>
                          {/* <td>{item.MNVClientID}</td> */}
                          <td>{item.TypeIDName}</td>
                          <td>{item.BusinessName}</td>
                          <td>{item.FirstName}</td>
                          <td>{item.LastName}</td>
                          <td>{item.EmailAddress}</td>
                          <td>{item.Mobile}</td>
                          <td>{item.Telephone}</td>
                          <td>{item.PostCode}</td>
                          <td>{item.Address}</td>
                          <td>{item.AddressLine2}</td>
                          <td>{item.VATNumber}</td>
                          <td>{item.ExtraTextField1}</td>
                          <td>{item.OtherEmails}</td>
                          <td className="text-right">{item.SurName}</td>                          
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>

          <div className={isFilterApplied == false ? "" : "no-display"}>
            <PaginatedItems
              itemsPerPage={thisComponentObject.RecordsPerPage}
              totalCount={thisComponentObject.TotalCount}
              pageIndexCallback={HandlePageIndexCallback}
              pageSelectionCallback={HandlePageSelectionCallback}
            />
          </div>
        </>
      )}

      {(isAddNew == 1 || isAddNew == 2) && (
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <>
            <div className="grid-d fr-111 gap-20">
              <div className="field-input grid-d  flex-gap3">
                <span className="font-12 text-left label-color">Type:</span>
                <select
                  className="input-field w-100"
                  value={addEditObject.TypeID}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      TypeID: e.target.value,
                    }))
                  }
                >
                  <option value="0">Please Select</option>
                  <option value="2">Residential</option>
                  <option value="1">Business</option>
                  {/* {dropDowndata &&
                    dropDowndata.map((item: any, index: any) => (
                      <React.Fragment key={index}>
                        <option value={item.pid}>{item.Name}</option>
                      </React.Fragment>
                    ))} */}
                </select>
              </div>
              {addEditObject.TypeID == 1 && (
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">
                    Business Name:
                  </span>
                  <input
                    className="input-field w-100"
                    value={addEditObject.BusinessName}
                    onChange={(e) =>
                      setAddEditObject((prevState: any) => ({
                        ...prevState,
                        BusinessName: e.target.value,
                      }))
                    }
                  />
                </div>
              )}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  First Name:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.FirstName}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      FirstName: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Last Name:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.LastName}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      LastName: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Email:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.EmailAddress}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      EmailAddress: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3 max-unset">
                <span className="font-12 text-left label-color">Mobile:</span>
                <MobileInput
                  SelectedMobileNumber={SelectedMobileNumber}
                  SetSelectedMobileNumber={SetSelectedMobileNumber}
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Telephone:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.Telephone}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Telephone: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Postcode:</span>
                <input
                  className="input-field w-100"
                  value={addEditObject.PostCode}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      PostCode: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Address Line 1:
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.Address}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      Address: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Address Line 2:
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.AddressLine2}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      AddressLine2: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Other Emails (comma seperated):
                </span>
                <textarea
                  className="input-field w-100"
                  rows={3}
                  value={addEditObject.OtherEmails}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      OtherEmails: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Payment Term:
                </span>
                <input
                  className="input-field w-100"
                  value={addEditObject.SurName}
                  onChange={(e) =>
                    setAddEditObject((prevState: any) => ({
                      ...prevState,
                      SurName: e.target.value,
                    }))
                  }
                />
              </div>
            </div>

            <div className="flex-daj gap-10 mt-20">
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => checkValidation()}
                >
                  {isAddNew == 1 ? "Save" : "Update"}
                </a>
              </div>
              <div className="flex-daj btn-start">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setIsAddNew(0)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default Clients;
